/**
 * © 2025. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 *
 * Manages fields, a replacement for JSON Schema.
 *
 * Created by Justin K Kazmierczak.
 */
var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "referrerpolicy",
    title: "Referrer Policy",
    description: "Controls how much referrer information is sent with web requests.",
    type: "field",
    use: {
        namespace: "ua.select"
    },
    tests: {
        validNoReferrer: {
            must: true,
            run: function () {
                return validate({ title: "Referrer Policy" }, "no-referrer");
            }
        },
        validStrictOrigin: {
            must: true,
            run: function () {
                return validate({ title: "Referrer Policy" }, "strict-origin-when-cross-origin");
            }
        },
        validEmpty: {
            must: true,
            run: function () {
                return validate({ title: "Referrer Policy" }, "");
            }
        },
        invalidValue: {
            throw: "fields.referrerpolicy.invalid",
            run: function () {
                return validate({ title: "Referrer Policy" }, "always");
            }
        },
        invalidType: {
            throw: "fields.referrerpolicy.notString",
            run: function () {
                return validate({ title: "Referrer Policy" }, true);
            }
        }
    },
    errors: {
        notString: {
            title: "Invalid Type",
            description: "The referrerpolicy value must be a string.",
            template: "Expected string but received ${typeof}"
        },
        invalid: {
            title: "Invalid Referrer Policy",
            description: "The referrerpolicy attribute must be one of the standard values defined by the Referrer Policy specification.",
            template: "Invalid referrerpolicy value: '${value}'. Must be one of: no-referrer, no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url, or empty."
        }
    }
});

var validValues = [
    "no-referrer",
    "no-referrer-when-downgrade",
    "origin",
    "origin-when-cross-origin",
    "same-origin",
    "strict-origin",
    "strict-origin-when-cross-origin",
    "unsafe-url",
    ""
];

function validate(spec, value) {
    if (typeof value !== "string") {
        _.errors.notString.throw({ typeof: typeof value });
    }

    if (!validValues.includes(value)) {
        _.errors.invalid.throw({ value: value });
    }
}
module.exports.validate = validate;
